'use client'

import type {
  AnnualReportSlideshow,
  Maybe,
} from '@/.generated/sanityTypes/graphql'
import './contentBlock.css'
import type { Locale } from '@/i18n'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useLocale } from 'next-intl'
import { LocalizedImage } from '@/components/Image'
import { cx } from '@monorepo/helper/cx'

const backgroundColorMap = {
  '#E6E6E6': 'bg-gray-dimmed',
  '#B3DAD7': 'bg-teal-500',
} as const
const backgroundDefaultColor = backgroundColorMap['#E6E6E6']

const getSlideBackgroundClass = (color?: Maybe<string>) => {
  if (!color || !backgroundColorMap.hasOwnProperty(color)) {
    return backgroundDefaultColor
  }

  return backgroundColorMap[color as keyof typeof backgroundColorMap]
}

const SlideshowBlock = ({
  interval,
  animationHandler,
  slides,
}: AnnualReportSlideshow) => {
  const locale = useLocale() as Locale

  return (
    <Slider
      className={getSlideBackgroundClass(slides?.[0]?.color)}
      dots={false}
      arrows={false}
      infinite={true}
      autoplay={true}
      autoplaySpeed={(interval || 1) * 1000}
      swipeToSlide={false}
      pauseOnHover={false}
      pauseOnFocus={false}
      fade={animationHandler !== 'slide'}
    >
      {slides?.map((slide) => (
        <div
          key={slide?._key || slide?.image?._key}
          className={cx(
            'text-darkBlue relative flex flex-col justify-center p-5 text-center md:p-20 md:text-3xl',
            getSlideBackgroundClass(slide?.color),
          )}
        >
          <p>{slide?.title?.[locale]}</p>
          <LocalizedImage
            className="my-5 w-full md:my-12"
            localeImage={slide?.image}
            alt={slide?.title?.[locale] || 'Slideshow Slide'}
          />
        </div>
      ))}
    </Slider>
  )
}

export default SlideshowBlock
